import TemplateRegistry from '@lit-any/core/template-registry';
import fallbackComponents from './FallbackComponents';
import TemplateSelectorBuilder from './TemplateSelectorBuilder';
// eslint-disable-next-line max-len
export default class FormTemplateRegistry extends TemplateRegistry {
    constructor(name) {
        super(name);
        this.components = fallbackComponents;
    }
    useComponents(components) {
        this.components = {
            ...fallbackComponents,
            ...components,
        };
        return this;
    }
    _createBuilder() {
        return new TemplateSelectorBuilder(this);
    }
}
